import * as Yup from 'yup';
import {
  ENGLISH_MATCHES,
  ENGLISH_MATCHES_WITH_SPACE,
  NUMBERS_MATCHES,
  VALID_YEAR_MATCHES,
} from '@uplift/constants';
import { l10nEnService } from '@uplift/services';

const l10n = l10nEnService;

const degrees = Yup.array().of(
  Yup.object().shape({
    school: Yup.string()
      .matches(ENGLISH_MATCHES, l10n.validations.couldContainEnglish)
      .max(64, l10n.validations.lengthMatches(1, 64))
      .required(l10n.validations.enterSchool),
    degree: Yup.string().required(l10n.validations.degree),
    field_of_study: Yup.string()
      .matches(
        ENGLISH_MATCHES_WITH_SPACE,
        l10n.validations.couldContainEnglishWithSpace
      )
      .max(50, l10n.validations.lengthMatches(1, 50))
      .required(l10n.validations.study),
    year_graduated: Yup.string()
      .matches(NUMBERS_MATCHES, l10n.validations.validYear)
      .matches(VALID_YEAR_MATCHES, l10n.validations.notRelevantDate)
      .min(4, l10n.validations.lengthEqual(4))
      .max(4, l10n.validations.lengthEqual(4))
      .required(l10n.validations.requiredYearGraduated),
  })
);

const yearsInPractice = Yup.string()
  .matches(NUMBERS_MATCHES, l10n.validations.digitsOnly)
  .max(2, l10n.validations.yearsInPracticeMax)
  .required(l10n.validations.practice);

export const validators = {
  degrees,
  yearsInPractice,
};
